import { Text } from '@/components/Text';
import React, { useMemo } from 'react';
import { textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { buttonVariants, Button } from '@/components/Button';
import styles from './Subscription.module.scss';
import { useSelector } from 'react-redux';
export const CancelSubscriptionModal = ({ onClose, onConfirm }) => {
  const subscriptionData = useSelector(
    (state) => state?.auth?.profile?.subscription
  );
  const { subscriptionEndDate } = useMemo(() => {
    return {
      subscriptionEndDate: subscriptionData?.subscriptionEndDate
        ?.toDate()
        .toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        }),
    };
  }, [subscriptionData]);

  return (
    <div className={styles.cancelSubscriptionModal}>
      <Text
        variant={textVariantsEnum.Text_lg}
        fontWeight={fontWeightEnum.Semibold}
      >
        Cancel Subscription
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        Are you sure you want to cancel your subscription?
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        Once you cancel your subscription, your access to app will be revoked
        after your current subscription cycle ends on{' '}
        <strong> {subscriptionEndDate}</strong>.
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        In order to continue using the app, you will need to purchase a new
        subscription.
      </Text>
      <div className={styles.buttonsContainer}>
        <Button
          variant={buttonVariants.secondary}
          text="Cancel"
          onClick={onClose}
        />
        <Button
          variant={buttonVariants.primary}
          text="Confirm"
          onClick={onConfirm}
        />
      </div>
    </div>
  );
};
